/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { item } from "examples/Sidenav/styles/sidenavItem";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 0,
    shtk: "",
    shtkBold: true,
    tentk: "LOẠI TÀI KHOẢN TÀI SẢN",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      spstk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      sdck: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
    },
  },
  {
    id: 1,
    shtk: "111",
    shtkBold: true,
    tentk: "Tiền mặt",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 2,
    shtk: "1111",
    shtkBold: false,
    tentk: "Tiền Việt Nam",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 3,
    shtk: "1112",
    shtkBold: false,
    tentk: "Ngoại tệ",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 4,
    shtk: "112",
    shtkBold: true,
    tentk: "Tiền gửi ngân hàng",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 5,
    shtk: "1121",
    shtkBold: false,
    tentk: "Tiền Việt Nam",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 6,
    shtk: "1122",
    shtkBold: false,
    tentk: "Ngoại tệ",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 7,
    shtk: "121",
    shtkBold: true,
    tentk: "Đầu tư tài chính",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 8,
    shtk: "1211",
    shtkBold: false,
    tentk: "Tiền gửi có kỳ hạn",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 9,
    shtk: "1218",
    shtkBold: false,
    tentk: "Đầu tư tài chính khác",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 10,
    shtk: "131",
    shtkBold: true,
    tentk: "Phải thu của khách hàng",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 11,
    shtk: "132",
    shtkBold: true,
    tentk: "Phải thu của hoạt động tín dụng nội bộ",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 12,
    shtk: "1321",
    shtkBold: false,
    tentk: "Phải thu hoạt động cho vay",
    tentkBold: false,
    readOnly: true,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 13,
    shtk: "13211",
    shtkBold: false,
    tentk: "Phải thu về gốc cho vay",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 14,
    shtk: "13212",
    shtkBold: false,
    tentk: "Phải thu về lãi cho vay",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 15,
    shtk: "1322",
    shtkBold: false,
    tentk: "Phải thu hoạt động tín dụng nội bộ khác",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 16,
    shtk: "133",
    shtkBold: true,
    tentk: "Thuế GTGT được khấu trừ",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 17,
    shtk: "1331",
    shtkBold: false,
    tentk: "Thuế GTGT được khấu trừ của hàng hóa, dịch vụ",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 18,
    shtk: "1332",
    shtkBold: false,
    tentk: "Thuế GTGT được khấu trừ của TSCĐ",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 19,
    shtk: "138",
    shtkBold: true,
    tentk: "Phải thu khác",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 20,
    shtk: "141",
    shtkBold: true,
    tentk: "Tạm ứng",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 21,
    shtk: "152",
    shtkBold: true,
    tentk: "Vật liệu, dụng cụ",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 22,
    shtk: "154",
    shtkBold: true,
    tentk: "Chi phí sản xuất, kinh doanh dở dang",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 23,
    shtk: "156",
    shtkBold: true,
    tentk: "Thành phẩm, hàng hóa",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 24,
    shtk: "157",
    shtkBold: true,
    tentk: "Hàng gửi đi bán",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 25,
    shtk: "211",
    shtkBold: true,
    tentk: "Tài sản cố định",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 26,
    shtk: "2111",
    shtkBold: false,
    tentk: "TSCĐ hữu hình",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 27,
    shtk: "2113",
    shtkBold: false,
    tentk: "TSCĐ vô hình",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 28,
    shtk: "214",
    shtkBold: true,
    tentk: "Hao mòn tài sản cố định",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 29,
    shtk: "2141",
    shtkBold: false,
    tentk: "Hao mòn TSCĐ hữu hình",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 30,
    shtk: "2143",
    shtkBold: false,
    tentk: "Hao mòn TSCĐ vô hình",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 31,
    shtk: "229",
    shtkBold: true,
    tentk: "Dự phòng tổn thất tài sản",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 32,
    shtk: "242",
    shtkBold: true,
    tentk: "Tài sản khác",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 33,
    shtk: "2421",
    shtkBold: false,
    tentk: "Chi phí trả trước",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 34,
    shtk: "2422",
    shtkBold: false,
    tentk: "Xây dựng cơ bản dở dang",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 35,
    shtk: "",
    shtkBold: true,
    tentk: "LOẠI TÀI KHOẢN NỢ PHẢI TRẢ",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      spstk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      sdck: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
    },
  },
  {
    id: 36,
    shtk: "331",
    shtkBold: true,
    tentk: "Phải trả cho người bán",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 37,
    shtk: "332",
    shtkBold: true,
    tentk: "Phải trả của hoạt động tín dụng nội bộ",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 38,
    shtk: "3321",
    shtkBold: false,
    tentk: "Phải trả từ hoạt động đi vay của thành viên",
    tentkBold: false,
    readOnly: true,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 39,
    shtk: "33211",
    shtkBold: false,
    tentk: "Phải trả về gốc vay",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 40,
    shtk: "33212",
    shtkBold: false,
    tentk: "Phải trả về lãi vay",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 41,
    shtk: "33212",
    shtkBold: false,
    tentk: "Phải trả hoạt động tín dụng nội bộ khác",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 42,
    shtk: "333",
    shtkBold: true,
    tentk: "Thuế và các khoản phải nộp nhà nước",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 43,
    shtk: "3331",
    shtkBold: false,
    tentk: "Thuế giá trị gia tăng phải nộp",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 44,
    shtk: "3334",
    shtkBold: false,
    tentk: "Thuế thu nhập doanh nghiệp",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 45,
    shtk: "3338",
    shtkBold: false,
    tentk: "Thuế khác, phí, lệ phí và các khoản khác phải nộp Nhà nước",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 46,
    shtk: "334",
    shtkBold: true,
    tentk: "Phải trả người lao động",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 47,
    shtk: "335",
    shtkBold: true,
    tentk: "Các khoản phải nộp theo lương",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 48,
    shtk: "338",
    shtkBold: true,
    tentk: "Phải trả khác",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 49,
    shtk: "341",
    shtkBold: true,
    tentk: "Phải trả nợ vay",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 50,
    shtk: "342",
    shtkBold: true,
    tentk: "Khoản trợ cấp, hỗ trợ của Nhà nước phải hoàn lại",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 51,
    shtk: "353",
    shtkBold: true,
    tentk: "Quỹ khen thưởng phúc lợi",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 52,
    shtk: "3531",
    shtkBold: false,
    tentk: "Quỹ khen thưởng",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 53,
    shtk: "3532",
    shtkBold: false,
    tentk: "Quỹ phúc lợi",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 54,
    shtk: "359",
    shtkBold: true,
    tentk: "Quỹ dự phòng rủi ro tín dụng",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 55,
    shtk: "",
    shtkBold: true,
    tentk: " LOẠI TÀI KHOẢN VỐN CHỦ SỞ HỮU",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: "" },
        co: { disable: false, value: "" },
      },
      spstk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      sdck: {
        no: { disable: true, value: "" },
        co: { disable: false, value: "" },
      },
    },
  },
  {
    id: 56,
    shtk: "411",
    shtkBold: true,
    tentk: "Vốn đầu tư của chủ sở hữu",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 57,
    shtk: "4111",
    shtkBold: false,
    tentk: "Vốn góp của thành viên",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 58,
    shtk: "4118",
    shtkBold: false,
    tentk: "Vốn khác",
    tentkBold: false,
    readOnly: false,
    valueBold: false,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 59,
    shtk: "418",
    shtkBold: true,
    tentk: "Các quỹ thuộc vốn chủ sở hữu",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 60,
    shtk: "421",
    shtkBold: true,
    tentk: "Lợi nhuận sau thuế chưa phân phối",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 61,
    shtk: "422",
    shtkBold: true,
    tentk: "Nguồn vốn trợ cấp, hỗ trợ không hoàn lại của Nhà nước",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 62,
    shtk: "",
    shtkBold: true,
    tentk: " LOẠI TÀI KHOẢN DOANH THU VÀ THU NHẬP",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: "" },
        co: { disable: false, value: "" },
      },
      spstk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      sdck: {
        no: { disable: true, value: "" },
        co: { disable: false, value: "" },
      },
    },
  },
  {
    id: 63,
    shtk: "511",
    shtkBold: true,
    tentk: "Doanh thu hoạt động sản xuất kinh doanh",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 64,
    shtk: "521",
    shtkBold: true,
    tentk: "Các khoản giảm trừ doanh thu",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 65,
    shtk: "546",
    shtkBold: true,
    tentk: "Doanh thu hoạt động tín dụng nội bộ",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 66,
    shtk: "558",
    shtkBold: true,
    tentk: "Thu nhập khác",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 67,
    shtk: "",
    shtkBold: true,
    tentk: "LOẠI TÀI KHOẢN CHI PHÍ",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: "" },
        co: { disable: false, value: "" },
      },
      spstk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      sdck: {
        no: { disable: true, value: "" },
        co: { disable: false, value: "" },
      },
    },
  },
  {
    id: 68,
    shtk: "632",
    shtkBold: true,
    tentk: "Giá vốn hàng bán",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 69,
    shtk: "642",
    shtkBold: true,
    tentk: "Chi phí quản lý kinh doanh",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 70,
    shtk: "646",
    shtkBold: true,
    tentk: "Chi phí hoạt động tín dụng nội bộ",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 71,
    shtk: "658",
    shtkBold: true,
    tentk: "Chi phí khác",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 72,
    shtk: "659",
    shtkBold: true,
    tentk: "Chi phí thuế thu nhập doanh nghiệp",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 73,
    shtk: "",
    shtkBold: true,
    tentk: "LOẠI TÀI KHOẢN XÁC ĐỊNH KẾT QUẢ KINH DOANH",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: "" },
        co: { disable: false, value: "" },
      },
      spstk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      sdck: {
        no: { disable: true, value: "" },
        co: { disable: false, value: "" },
      },
    },
  },
  {
    id: 74,
    shtk: "911",
    shtkBold: true,
    tentk: "Xác định kết quả kinh doanh",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: true, value: 0 },
        co: { disable: true, value: 0 },
      },
    },
  },
  {
    id: 75,
    shtk: "",
    shtkBold: true,
    tentk: "TỔNG CỘNG",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 76,
    shtk: "",
    shtkBold: true,
    tentk: "TÀI KHOẢN LOẠI 0",
    tentkBold: true,
    readOnly: true,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      spstk: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
      sdck: {
        no: { disable: false, value: "" },
        co: { disable: false, value: "" },
      },
    },
  },
  {
    id: 77,
    shtk: "001",
    shtkBold: true,
    tentk: "Tài sản thuê ngoài",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 78,
    shtk: "002",
    shtkBold: true,
    tentk: "Vật tư, hàng hóa nhận giữ hộ, nhận gia công",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 79,
    shtk: "003",
    shtkBold: true,
    tentk: "Hàng hóa nhận bán hộ, nhận ký gửi",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 80,
    shtk: "004",
    shtkBold: true,
    tentk: "Nợ khó đòi đã xử lý",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 81,
    shtk: "005",
    shtkBold: true,
    tentk: "Công cụ dụng cụ lâu bền đang sử dụng",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 82,
    shtk: "006",
    shtkBold: true,
    tentk: "Tài sản đảm bảo khoản vay",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 83,
    shtk: "007",
    shtkBold: true,
    tentk: "Ngoại tệ các loại",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
  {
    id: 84,
    shtk: "008",
    shtkBold: true,
    tentk: "Lãi cho vay quá hạn khó có khả năng thu được",
    tentkBold: true,
    readOnly: false,
    valueBold: true,
    value: {
      sddk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      spstk: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
      sdck: {
        no: { disable: false, value: 0 },
        co: { disable: false, value: 0 },
      },
    },
  },
];
function Table3({ setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values.e;
    const type = values.type;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          if (name === "sdck") {
            if (type === "no") {
              item.value.sdck.no.value = value;
            }
            if (type === "co") {
              item.value.sdck.co.value = value;
            }
          }
          if (name === "sddk") {
            if (type === "no") {
              item.value.sddk.no.value = value;
            }
            if (type === "co") {
              item.value.sddk.co.value = value;
            }
          }
          if (name === "spstk") {
            if (type === "no") {
              item.value.spstk.no.value = value;
            }
            if (type === "co") {
              item.value.spstk.co.value = value;
            }
          }
        }
        return item;
      })
    );
    // console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tính: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Số hiệu tài khoản</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Tên tài khoản</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan={2}>
                Số dư đầu kỳ
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan={2}>
                Số phát sinh trong kỳ
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} colSpan={2}>
                Số dư cuối kỳ
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}></Th>
              <Th style={{ textAlign: "center" }}></Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Nợ</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Có</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Nợ</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Có</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Nợ</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>Có</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>A</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>B</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>1</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>2</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>1</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>2</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>1</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>2</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((rows) => (
                <tr key={rows.id}>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.shtkBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.shtk}
                  </Td>
                  <Td
                    style={{
                      textAlign: "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.tentkBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.tentk}
                  </Td>
                  {/* -- */}
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background:
                        rows.readOnly === true
                          ? rows.value.sddk.no.disable === true
                            ? "#DCDCDC"
                            : "#ddeff3"
                          : rows.value.sddk.no.disable === true
                          ? "#DCDCDC"
                          : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="sddk"
                      readOnly={rows.value.sddk.no.disable === true ? true : rows.readOnly}
                      value={rows.value.sddk.no.value}
                      onChange={(e) => handleChange({ e, type: "no" })}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background:
                        rows.readOnly === true
                          ? rows.value.sddk.co.disable === true
                            ? "#DCDCDC"
                            : "#ddeff3"
                          : rows.value.sddk.co.disable === true
                          ? "#DCDCDC"
                          : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="sddk"
                      title="co"
                      readOnly={rows.value.sddk.co.disable === true ? true : rows.readOnly}
                      value={rows.value.sddk.co.value}
                      onChange={(e) => handleChange({ e, type: "co" })}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  {/* -- */}
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background:
                        rows.readOnly === true
                          ? rows.value.spstk.no.disable === true
                            ? "#DCDCDC"
                            : "#ddeff3"
                          : rows.value.spstk.no.disable === true
                          ? "#DCDCDC"
                          : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="spstk"
                      readOnly={rows.value.spstk.no.disable === true ? true : rows.readOnly}
                      value={rows.value.spstk.no.value}
                      onChange={(e) => handleChange({ e, type: "no" })}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background:
                        rows.readOnly === true
                          ? rows.value.spstk.co.disable === true
                            ? "#DCDCDC"
                            : "#ddeff3"
                          : rows.value.spstk.co.disable === true
                          ? "#DCDCDC"
                          : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="spstk"
                      title="co"
                      readOnly={rows.value.spstk.co.disable === true ? true : rows.readOnly}
                      value={rows.value.spstk.co.value}
                      onChange={(e) => handleChange({ e, type: "co" })}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  {/* -- */}
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background:
                        rows.readOnly === true
                          ? rows.value.sdck.no.disable === true
                            ? "#DCDCDC"
                            : "#ddeff3"
                          : rows.value.sdck.no.disable === true
                          ? "#DCDCDC"
                          : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="sdck"
                      readOnly={rows.value.sdck.no.disable === true ? true : rows.readOnly}
                      value={rows.value.sdck.no.value}
                      onChange={(e) => handleChange({ e, type: "no" })}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background:
                        rows.readOnly === true
                          ? rows.value.sdck.co.disable === true
                            ? "#DCDCDC"
                            : "#ddeff3"
                          : rows.value.sdck.co.disable === true
                          ? "#DCDCDC"
                          : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="sdck"
                      title="co"
                      readOnly={rows.value.sdck.co.disable === true ? true : rows.readOnly}
                      value={rows.value.sdck.co.value}
                      onChange={(e) => handleChange({ e, type: "co" })}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  {/* -- */}
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(Table3);

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function InputTable2(props) {
  const { id, onChange, type, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
